import { Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class MenuDataService {
  menuData: any = {
    data: null,
    selected: null,
  };

  constructor(private appService: AppService) {}

  setData(_data: any): any {
    this.mergeNonMatchedTaskHierarchy(_data);
    this.buildMenuIds(_data);
    this.setTreeParent(_data, 'children');
    this.setOpen(_data, true, false);
    this.menuData.data = _data;
    return _data;
  }

  setOpen(menu: any, isOpen: any, isChildOpen: any): void {
    if (menu?.length >= 0) {
      menu.forEach((item: any) => {
        item.collapsed = !isOpen;
        if (Array.isArray(item.children)) {
          this.setOpen(item.children, isChildOpen, isChildOpen);
        }
      });
    }
  }

  pipe(_search: any): void {
    this.toggleMenu(false);
    this.setTreeAttribute(this.menuData.data, 'hidden', 'children', false);
    this.filterTree(this.menuData.data, _search, 'label', 'children');
  }

  toggleMenu(value: any): void {
    this.setTreeAttribute(this.menuData.data, 'collapsed', 'children', value);
  }

  setSelected(obj: any): void {
    this.menuData.selected = obj;
    function setParent(o: any) {
      if (o.parent) {
        o.parent.selected = true;
        o.parent.collapsed = false;
        setParent(o.parent);
      }
    }
    setParent(obj);
  }

  removeSelected(): void {
    if (this.menuData.data) {
      this.removeTreeAttribute(this.menuData.data, 'selected', 'children');
    }
  }

  buildMenuIds(jsonArray: any): void {
    for (let i = 0; i < jsonArray.length; i++) {
      jsonArray[i].menu_id = jsonArray[i].label?.replace(/ /g, '-');
      if (jsonArray[i].children !== undefined) {
        this.buildMenuIds(jsonArray[i].children);
      }
    }
  }

  mergeNonMatchedTaskHierarchy(jsonAry: any): void {
    for (let i = 0; i < jsonAry.length; i++) {
      const chlObj = jsonAry[i];
      if (chlObj.children?.length) {
        for (let c = 0; c < chlObj.children.length; c++) {
          const childTaskObj = chlObj.children[c];
          const childObjList = _.filter(chlObj.children, {
            parentTaskKey: childTaskObj.id,
          });
          if (childObjList.length) {
            childTaskObj.processed = true;
            for (let j = 0; j < childObjList.length; j++) {
              if (childTaskObj.children) {
                childTaskObj.children.unshift(childObjList[j]);
              } else {
                childTaskObj.children = [childObjList[j]];
              }
            }
          }
        }
      }
      jsonAry[i].children = _.filter(jsonAry[i].children, { parentTaskKey: null });
    }
  }

  filterTree(collection: any, value: any, predicate: any, children: any): void {
    for (let i = 0; i < collection.length; i++) {
      const n = collection[i][predicate];
      let checkChildren = true;
      if (n) {
        if (_.includes(n.toLowerCase(), value.toLowerCase())) {
          collection[i].hidden = false;
          checkChildren = false;
        } else {
          collection[i].hidden = true;
        }
        if (checkChildren && collection[i][children]?.length) {
          this.filterTree(collection[i][children], value, predicate, children);
          let parentHidden = true;
          const innerChildren = collection[i][children];
          for (let p = 0; p < innerChildren.length; p++) {
            if (!innerChildren[p].hidden) { parentHidden = false; }
          }
          if (checkChildren) { collection[i].hidden = parentHidden; }
        }
      }
    }
  }

  removeTreeAttribute(_collection: any, _predicate: any, _children: any): void {
    for (let i = 0; i < _collection.length; i++) {
      const children = _collection[i][_children];
      if (children?.length) {
        this.removeTreeAttribute(children, _predicate, _children);
      }
      if (_collection[i][_predicate]) {
        _collection[i][_predicate] = undefined;
      }
    }
  }

  setTreeAttribute(_collection: any, _predicate: any, _children: any, value: any): void {
    for (let i = 0; i < _collection.length; i++) {
      const children = _collection[i][_children];
      if (children?.length) {
        this.setTreeAttribute(children, _predicate, _children, value);
      }
      _collection[i][_predicate] = value;
    }
  }

  setTreeParent(_collection: any, _children: any): void {
    for (let i = 0; i < _collection.length; i++) {
      const thisChildren = _collection[i][_children];
      if (thisChildren?.length) {
        this.setTreeParent(thisChildren, _children);
      }
      if (thisChildren) {
        for (const n in thisChildren) {
          thisChildren[n].parent = _collection[i];
        }
      }
      if (_collection[i].type === 'activity' && _collection[i].screens?.length) {
        const screens = _collection[i].screens;
        for (const n in screens) {
          screens[n].parent = _collection[i];
        }
      }
    }
  }
}
